import { ReactNode } from "react";

const COMPONENT_CLASS = "c-card-button";

interface CardButtonProps {
    icon: ReactNode;
    label: string;
    onClick: () => void;
    height?: number;
}

const CardButton: React.FC<CardButtonProps> = (props) => {
    const { icon, label, onClick, height } = props;

    return (
        <button
            className={COMPONENT_CLASS}
            onClick={onClick}
            type="button"
            style={height ? { minHeight: `${height}px` } : undefined}
        >
            {icon}
            <span className={`${COMPONENT_CLASS}__label body-bold`}>{label}</span>
        </button>
    );
};

export default CardButton;
